/* eslint-disable react/require-default-props */
import React, { useCallback, useRef } from 'react';

import { FormHandles } from '@unform/core';

import { FiX, FiEdit2 } from 'react-icons/fi';

import * as Yup from 'yup';

import { useToast } from '../../../../hooks/toast';
import getValidationErrors from '../../../../utils/getValidationErrors';

import { Form, DivLeft } from '../ModalAddBranch/styles';
import { IBranchForm, branchSchema, formatBranchData } from '../ModalAddBranch';

import Input from '../../../Global/Input';
import Button from '../../../Global/Button';

import Modal from '../index';
import { api } from '../../../../services/api';

interface IBranch extends IBranchForm {
  id: string;
}

interface IModalProps {
  isOpen: boolean;
  setIsOpen: () => void;
  handleBranch: () => void;
  dataEditBranch?: IBranch;
}

const ModalEditBranch: React.FC<IModalProps> = ({
  isOpen,
  setIsOpen,
  handleBranch,
  dataEditBranch,
}) => {
  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: IBranchForm) => {
      try {
        formRef.current?.setErrors({});

        await branchSchema.validate(data, {
          abortEarly: false,
        });

        await api.put('/branches', {
          id: dataEditBranch?.id,
          ...formatBranchData(data),
        });

        setIsOpen();
        handleBranch();

        addToast({
          type: 'success',
          title: 'Filial',
          description: 'Filial atualizada com sucesso',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        console.log(err);
        setIsOpen();
        addToast({
          type: 'error',
          title: 'Erro na ação',
          description: 'Recarregue a pagina e tente novamente.',
        });
      }
    },
    [dataEditBranch, handleBranch, setIsOpen, addToast],
  );

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Form ref={formRef} onSubmit={handleSubmit} initialData={dataEditBranch}>
        <span>
          <div>
            <h2>Editar filial</h2>
            <FiEdit2 size={20} />
          </div>

          <FiX size={20} onClick={() => setIsOpen()} />
        </span>

        <p>Nome completo</p>
        <Input
          name="full_name"
          placeholder="Ex: Razão social completa da filial"
        />

        <p>Nome curto (aparece nas listas do PIC e da despesa)</p>
        <Input name="short_name" placeholder="Ex: Matriz" />

        <p>CNPJ</p>
        <Input name="cnpj" placeholder="Ex: 00.000.000/0000-00" />

        <p>Endereço completo</p>
        <Input
          name="address"
          placeholder="Ex: Rua, número, bairro, cidade - UF"
        />

        <p>Endereço resumido / cidade</p>
        <Input name="short_address" placeholder="Ex: Rio Verde - GO" />

        <DivLeft>
          <Button type="submit" groud={false} disabled={false} isUsed={false}>
            Salvar
          </Button>
        </DivLeft>
      </Form>
    </Modal>
  );
};

export default ModalEditBranch;
